// (A) 중립 Drawer API — antd 미접촉. (B) PlainDrawer(Radix Dialog side variant)에 위임.
import type { CSSProperties, ReactNode } from 'react'
import { PlainDrawer } from '../_impl/PlainDrawer'

export type OmwDrawerPlacement = 'top' | 'right' | 'bottom' | 'left'

export interface OmwDrawerProps {
  open?: boolean
  onClose?: () => void
  title?: ReactNode
  /** 실측: 400 · 300 · '...'. */
  width?: number | string
  placement?: OmwDrawerPlacement
  closable?: boolean
  /** 실측: null(닫기 아이콘 숨김). */
  closeIcon?: ReactNode
  destroyOnHidden?: boolean
  footer?: ReactNode
  className?: string
  /** 실측: styles.body(패딩 0) → 중립 bodyStyle 로 흡수. */
  bodyStyle?: CSSProperties
  /** 팝업 컨테이너(실측: tablet 모드에서 특정 컬럼에 마운트). */
  getContainer?: (() => HTMLElement) | false
  /** 루트 스타일(실측: tablet position:absolute). */
  rootStyle?: CSSProperties
  children?: ReactNode
}

export function OmwDrawer(props: OmwDrawerProps) {
  return <PlainDrawer {...props} />
}
